import { getUserData } from './services';

export const canShowMenuItem = (val) => {
    const userData = getUserData();
    return val.roles.includes(userData.user.rol);
};
